import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/combo-hero.jpg")